// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"src_app_layouts_admin-layout_admin-layout_module_ts":"99682e08c9f74b19","src_app_pages_stock-batch_stock-batch_module_ts":"a3f5c16f2350ebc4"}[chunkId] + ".js";
};